<template>
  <div>
    <div class="container-types top-banner" style="margin-left: 14px;">
      <h3 class="types-title clearfix">
        <span>{{ dataModel.videoCategoryEntity.name }}</span>
      </h3>
    </div>
    <div>
      <div>
        <div
          v-if="
            dataModel.secondCategoryList &&
              dataModel.secondCategoryList.length > 0
          "
          class="container-types"
        >
          <div class="types-title clearfix">
            <ul class="js-rank-tab" style="margin-left: 0;padding: 0;">
              <li
                class="mianfei"
                :class="{ curr: currentTabIndex == secIndex }"
                v-for="(secItem, secIndex) in dataModel.secondCategoryList"
                @click="swichCategory(secIndex)"
              >
                {{ secItem.videoCategoryVo.name }}
              </li>
            </ul>
          </div>
        </div>
        <div>
          <el-row :gutter="100">
            <el-col
              :span="8"
              v-for="(subItem, subIndex) in dataModel.secondCategoryList[
                currentTabIndex
              ].videoCourseEntityList"
              :key="subItem.id"
            >
              <a style="cursor:pointer" @click="toVideoDetail(subItem)">
                <div class="case-grid-content">
                  <div class="case-img-container">
                    <img :src="subItem.videoThumb" v-if="subItem.videoThumb" />
                    <img v-else src="../../assets/img/logo.png" />
                  </div>

                  <p class="title">{{ subItem.name }}</p>
                  <p class="desc">
                    适用学段：{{ gradeIdsConvert(subItem.gradeIds) }} 作者：{{
                      subItem.teacherName
                    }}
                  </p>
                  <p class="desc">
                    课程分类: {{ nameMap[subItem.categoryId] }}
                  </p>
                </div>
              </a>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <login-dialog
      v-if="loginDialogVisible"
      :afterUrl="afterUrl"
      ref="loginDialog"
    />
    <my-footer />
  </div>
</template>

<script>
import { gradeIdsToName } from "../../utils";
import MyFooter from "./my-footer";
import Vue from "vue";
import LoginDialog from "../navbar-login-dialog";
import { gradeTypeOption } from "../../utils/constant";
export default {
  components: {
    MyFooter,
    LoginDialog
  },
  data() {
    return {
      prefixIcon: require("../../assets/img/icon_prefix_search.png"),
      dataForm: {
        key: "",
        gradeType: 1
      },
      isLogin: false,
      treeData: [],
      nameMap: {},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      gradeTypeOption: gradeTypeOption,
      loginDialogVisible: false,
      afterUrl: undefined,
      categoryMap: [],
      categoryIndexMap: [],
      dataModel: {},
      categoryId: undefined,
      currentTabIndex: 0,
      sid: undefined
    };
  },

  activated() {},
  created() {
    if (
      !Vue.cookie.get("eterc-ai-token") ||
      !/\S/.test(Vue.cookie.get("eterc-ai-token"))
    ) {
      this.isLogin = false;
    } else {
      this.isLogin = true;
    }
    this.categoryId = this.$route.query.cid;
    this.sid = this.$route.query.sid;
    this.getCategoryList();
    this.getDataList();
  },
  methods: {
    swichCategory(index) {
      this.currentTabIndex = index;
      this.categoryMap.splice(
        index,
        1,
        this.dataModel.secondCategoryList[index]
      );
    },
    gradeIdsConvert(gradeIds) {
      return gradeIdsToName(gradeIds);
    },
    showLoginPop() {
      var isLogin = false;
      if (
        !Vue.cookie.get("eterc-ai-token") ||
        !/\S/.test(Vue.cookie.get("eterc-ai-token"))
      ) {
        isLogin = false;
      } else {
        isLogin = true;
      }
      if (!isLogin) {
        this.loginDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.loginDialog.init();
        });
      }
      return isLogin;
    },
    getCategoryList() {
      this.$requst.get("/business/videocategory/tree").then(({ data }) => {
        this.treeData = [data.data];
        let nameMap = {};
        let getNames = (tree, name) => {
          if (tree && tree.length > 0) {
            for (let item of tree) {
              // console.log("name="+item.name)
              let showName;
              if (name === "") {
                showName = item.name;
              } else {
                showName = name + "/" + item.name;
              }
              nameMap[item.id] = showName;
              if (item.children) {
                getNames(item.children, showName);
              }
            }
          }
        };
        getNames(data.data.children, "");
        this.nameMap = nameMap;
      });
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl(
          `/business/videocourse/singleCategoryData/${this.categoryId}`
        ),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataModel = data.data;
          var secCategory = data.data.secondCategoryList;
          this.categoryMap[0] = secCategory[0];
          if (this.sid) {
              secCategory.forEach((element, index) => {
                if (element.videoCategoryVo.id == this.sid) {
                    this.currentTabIndex = index
                }
              });
          }
        } else {
          this.dataList = {};
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    loadMore() {
      this.pageIndex++;
      this.getDataList();
    },
    toVideoDetail(item) {
      this.afterUrl = {
        path: "video-sample-detail",
        query: { id: item.id }
      };
      if (this.showLoginPop()) {
        this.$router.push({
          path: "video-sample-detail",
          query: { id: item.id }
        });
      }
    }
  }
};
</script>

<style lang="scss">
.top-banner {
  margin-top: 30px;
  img {
    width: 100%;
  }
}

.banner-text {
  font-family: HiraginoSansGB-W3;
  font-size: 21px;
  color: #0068b6;
  letter-spacing: 0;
  text-align: center;
  padding: 30px 156px;
}
.top-tool-container {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
.container-types .types-title {
  position: relative;
  font-size: 24px;
  color: #1c1f21;
  letter-spacing: 0px;
  line-height: 32px;
}
.container-types .types-title span {
  float: left;
  font-weight: bold;
}
.container-types .types-title ul {
  float: left;
  margin: 0;
  margin-left: 36px;
  width: 80%;
}

.container-types .types-title ul li:hover {
  color: #4a90e2;
}
.container-types .types-title ul li {
  margin: 0px 14px;
  float: left;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 30px;
  cursor: pointer;
  color: #545c63;
}

.container-types .types-title ul li.curr {
  color: #4a90e2;
  border-bottom: 2px solid #4a90e2;
  margin-bottom: -2px;
}

</style>
